import { Button, LinkButton } from '@app/components';
import { useEnhancedTranslation } from '@app/hooks';
import { useNavigate } from 'react-router-dom';

import './not-found.page.scss';

export const NotFoundPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useEnhancedTranslation({ keyPrefix: 'notFound' });
  return (
    <main className="not-found">
      <h1 className="not-found__title">{t('pageDoesntExist')}</h1>
      <div className="not-found__btn-group">
        <Button invertColors onClick={() => navigate(-1)} className="not-found__btn">
          {t('goBack')}
        </Button>
        <LinkButton invertColors to="/" className="not-found__btn">
          {t('goToMain')}
        </LinkButton>
      </div>
      <p className="not-found__404">{t('404')}</p>
    </main>
  );
};
